// src/Auth/Auth.js
import React, {useState, useRef} from 'react';
import {registerUser, loginUser, loginWithGoogle, checkUserExists} from './authservice';
import {sendResetPassword} from './passwordReset';
import logocooky from '../Icons/logocooky.png';
import googleIcon from '../Icons/google.jpg';
import './Auth.css';

const initialProfile = {
    tipoCocina: "",
    genero: "",
    profileImage: "",
};

const Auth = () => {
    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [profile, setProfile] = useState(initialProfile);
    const [isRegistering, setIsRegistering] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [showResetMsg, setShowResetMsg] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const fileInputRef = useRef();

    const handleProfileImage = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => setProfile((p) => ({...p, profileImage: ev.target.result}));
        reader.readAsDataURL(file);
   };

    const handleResetPassword = async () => {
        setError('');
        setShowResetMsg(false);
        try {
            await sendResetPassword(email);
            setShowResetMsg(true);
       } catch (err) {
            setError(err.message);
       }
   };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            if (isRegistering) {
                if (!userName || !email || !password || !repeatPassword) throw new Error("Completa todos los campos obligatorios.");
                if (password !== repeatPassword) throw new Error("Las contraseñas no coinciden.");
                if (isRegistering && !acceptedTerms) {
                    setError("Debes aceptar los Términos y Condiciones para registrarte.");
                    setIsLoading(false);
                    return;
               }
                await registerUser(email, password, userName, profile);
                // Puedes redirigir o mostrar mensaje de éxito aquí
           } else {
                if (!email || !password) throw new Error("Completa todos los campos.");
                const user = await loginUser(email, password);
                const userExists = await checkUserExists(user.uid);
                if (!userExists) throw new Error("Usuario no registrado.");
                // Puedes redirigir aquí
           }
       } catch (err) {
            // Detecta error de credenciales inválidas
            if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found') {
                setError("Usuario y/o Contraseña no válidos");
           } else {
                setError(err.message);
           }
       } finally {
            setIsLoading(false);
       }
   };

    const handleGoogleLogin = async () => {
        setError('');
        setIsLoading(true);
        try {
            await loginWithGoogle();
            // Puedes redirigir aquí
       } catch (err) {
            setError(err.message);
       } finally {
            setIsLoading(false);
       }
   };

    return (
        <div className="auth-container">
            <div className="auth-title-row">
                <span className="auth-title">CookyChat</span>
                <img src={logocooky} alt="logo" className="auth-logo" />
            </div>
            <form className="auth-form" onSubmit={handleSubmit}>
                {error && <div className="auth-error">{error}</div>}
                {showResetMsg && (
                    <div className="auth-error" style={{color: "#4E7D3A"}}>
                        Se ha enviado un email de recuperación.
                    </div>
                )}
                {!isRegistering ? (
                    <>
                        <input
                            className="auth-input"
                            type="text"
                            placeholder="Email o Nombre Usuario"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="username"
                        />
                        <input
                            className="auth-input"
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                        />
                        <span className="auth-link" onClick={handleResetPassword}>
                            Olvidé mi contraseña
                        </span>
                        <button
                            type="submit"
                            className="auth-register-btn"
                            disabled={isLoading}
                        >
                            Iniciar Sesión
                        </button>
                        <button
                            type="button"
                            className="auth-google-btn"
                            onClick={handleGoogleLogin}
                            disabled={isLoading}
                        >
                            <img src={googleIcon} alt="Google" style={{width: 22, height: 22}} />
                            Iniciar Sesión con Google
                        </button>
                        <button
                            type="button"
                            className="auth-register-btn"
                            style={{background: "#fff", color: "#4E7D3A", border: "1px solid #4E7D3A"}}
                            onClick={() => setIsRegistering(true)}
                            disabled={isLoading}
                        >
                            Registrarse
                        </button>
                    </>
                ) : (
                    <>
                        <input
                            className="auth-input"
                            type="text"
                            placeholder="Nombre de usuario"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            autoComplete="username"
                            required
                        />
                        <input
                            className="auth-input"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            required
                        />
                        <input
                            className="auth-input"
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            required
                        />
                        <input
                            className="auth-input"
                            type="password"
                            placeholder="Repetir contraseña"
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)}
                            autoComplete="new-password"
                            required
                        />
                        <div className="auth-profile-section">
                            <label className="auth-profile-label">Imagen de perfil</label>
                            <img
                                src={profile.profileImage || logocooky}
                                alt="Perfil"
                                className="auth-profile-image"
                                onClick={() => fileInputRef.current.click()}
                                title="Haz click para subir imagen"
                            />
                            <input
                                type="file"
                                accept="image/*"
                                ref={fileInputRef}
                                style={{display: "none"}}
                                onChange={handleProfileImage}
                            />
                            <label className="auth-profile-label">Tipo de cocina favorita</label>
                            <input
                                className="auth-input"
                                type="text"
                                placeholder="Ej: Mediterránea, Asiática..."
                                value={profile.tipoCocina}
                                onChange={e => setProfile(p => ({...p, tipoCocina: e.target.value}))}
                            />
                            <label className="auth-profile-label">Género</label>
                            <select
                                className="auth-profile-select"
                                value={profile.genero}
                                onChange={e => setProfile(p => ({...p, genero: e.target.value}))}
                            >
                                <option value="">Selecciona tu género</option>
                                <option value="Hombre">Hombre</option>
                                <option value="Mujer">Mujer</option>
                                <option value="Prefiero no contestar">Prefiero no contestar</option>
                            </select>
                        </div>
                        <label style={{display: 'flex', alignItems: 'center', margin: '10px 0'}}>
                            <input
                                type="checkbox"
                                checked={acceptedTerms}
                                onChange={e => setAcceptedTerms(e.target.checked)}
                                required
                                style={{marginRight: 8}}
                            />
                            He leído y acepto los{' '}
                            <a
                                href="/terminos"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color: '#4E7D3A', textDecoration: 'underline', marginLeft: 4}}
                            >
                                Términos y Condiciones
                            </a>
                        </label>
                        <button
                            type="submit"
                            className="auth-register-btn"
                            disabled={isLoading}
                        >
                            Registrarse
                        </button>
                        <button
                            type="button"
                            className="auth-link"
                            style={{background: "none", border: "none", color: "#4E7D3A", marginTop: 10}}
                            onClick={() => setIsRegistering(false)}
                            disabled={isLoading}
                        >
                            Ya tengo cuenta
                        </button>
                    </>
                )}
            </form>
        </div>
    );
};

export default Auth;